module.exports = __webpack_public_path__ + "static/media/header-2025.3802f15f.jpg";